export default "__VITE_ASSET__DClZV1mu__"